import React, { Fragment } from "react";
import PropTypes from "prop-types";

const propTypes = {
  scooter: PropTypes.object.isRequired
};

const Scooter = ({ scooter, keyTag }) => (

    <div className="row">
      <div className="col-auto scooter" >
        <label>
        {keyTag && (
          <Fragment>
            Key Tag: <b>{keyTag} </b>
          </Fragment>
        )}
        Vin:<b>{scooter.vin} </b> License Plate:<b>{scooter.license_plate} </b>
        Brand:<b>{scooter.brand} </b> Model:
        <b>
          {scooter.model} {scooter.year} {scooter.color}{" "}
        </b>
      </label>
    </div>
  </div>
);

Scooter.propTypes = propTypes;

export default Scooter;
